export const tratonPreset = {
	semantic: {
		primary: {
			50: '#f8fcfc',
			100: '#e9f5f6',
			200: '#b3dce1',
			300: '#8ccad2',
			400: '#66b8c4',
			500: '#2d9ead',
			600: '#008294',
			700: '#006371',
			800: '#004852',
			850: '#003137',
			900: '#002429',
			950: '#001d21',
			1000: '#001214',
		},
		colorScheme: {
			light: {
				text: {
					color: '#1A1A19',
				},
				surface: {
					50: '#fcfbf7',
					100: '#f6f3e9',
					150: '#ebe7dd',
					200: '#d6d4c9',
					300: '#c2bfb6',
					400: '#a6a49c',
					500: '#8c8a84',
					600: '#73716c',
					700: '#595854',
					800: '#454441',
					900: '#252423',
					950: '#1a1a19',
				},
			},
			dark: {
				primary: {
					color: '#d9edf0',
					contrastColor: '{surface.950}',
					hoverColor: '{surface.100}',
					activeColor: '{surface.200}',
				},
				content: {
					background: '{surface.950}',
					color: '#d9edf0',
				},
				navigation: {
					item: {
						color: '#d9edf0',
					},
				},
				formField: {
					background: '{surface.1000}',
					borderColor: '{surface.700}',
					hoverBorderColor: '{surface.600}',
					focusBorderColor: '{surface.600}',
					color: '#d9edf0',
					placeholderColor: '{surface.200}',
					floatLabelColor: '{surface.200}',
					floatLabelActiveColor: '{surface.200}',
					iconColor: '{surface.200}',
				},
				text: {
					color: '#d9edf0',
					mutedColor: '{surface.200}',
					hoverMutedColor: '{surface.300}',
				},
				surface: {
					50: '#f8fcfc',
					100: '#e9f5f6',
					200: '#b3dce1',
					300: '#8ccad2',
					400: '#66b8c4',
					500: '#2d9ead',
					600: '#008294',
					700: '#006371',
					800: '#004852',
					850: '#003137',
					900: '#002429',
					950: '#001d21',
					1000: '#001214',
				},
			},
		},
	},
};
